import Alpine from 'alpinejs';

Alpine.data('store_opening', (operatingHours, locales) => ({
  status: {
    code: '',
    message: '',
  },
  init() {
    const tz = operatingHours.timezone || 'Australia/Melbourne';
    const nextDay = { Sun: 'Mon', Mon: 'Tue', Tue: 'Wed', Wed: 'Thu', Thu: 'Fri', Fri: 'Sat', Sat: 'Sun' };

    // Get current time in the STORE's timezone
    const now = new Date();
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
      weekday: 'short',
    }).formatToParts(now);

    const dayName = parts.find(p => p.type === 'weekday').value;
    const hour = parseInt(parts.find(p => p.type === 'hour').value, 10);
    const minute = parseInt(parts.find(p => p.type === 'minute').value, 10);
    const currentTime = hour + minute / 60;

    const todayHours = operatingHours.hours[dayName];
    const tomorrowHours = operatingHours.hours[nextDay[dayName]];

    if (!todayHours || !tomorrowHours) {
      this.status = { code: 'closed', message: locales.closed };
      return;
    }

    const today = this.parse(todayHours);
    const tomorrow = this.parse(tomorrowHours);

    if (today.start.parsed === -1) {
      this.status = { code: 'closed', message: locales.closed };
      return;
    }

    if (currentTime < today.start.parsed) {
      this.status = {
        code: 'opens',
        message: `${locales.opens} ${today.start.opening}am`,
      };
    } else if (currentTime >= today.start.parsed && currentTime < today.end.parsed) {
      this.status = { code: 'open', message: `${locales.open}` };
    } else {
      this.status = {
        code: 'closed',
        message: tomorrow.start.parsed !== -1
          ? `${locales.closed} ${tomorrow.start.opening}am`
          : locales.closed,
      };
    }
  },

  minute(min) {
    return Number(min) / 60;
  },

  hour(hour, twentyFourHour = true) {
    const parsedHour = Number(hour);
    if (!twentyFourHour) return parsedHour;
    return parsedHour + 12;
  },

  time(time, twentyFourHour = true) {
    if (!time.includes(':')) return this.hour(time, twentyFourHour);
    const [hour, minute] = time.split(':');
    if (minute.includes('00')) return this.hour(hour, twentyFourHour);
    if (!twentyFourHour) return `${Number(hour) + this.minute(minute)}`;
    return `${this.hour(hour) + this.minute(minute)}`;
  },

  parse(times) {
    if (!times || !times.includes('-')) {
      return { start: { opening: '', parsed: -1 }, end: { close: '', parsed: -1 } };
    }
    const [time, _] = times.split('pm');
    const [opening, close] = time.split('-');
    return {
      start: {
        opening,
        parsed: this.time(opening, false),
      },
      end: {
        close,
        parsed: this.time(close),
      },
    };
  },

  open_hours: {
    [':data-ui']() {
      return this.status.code;
    },
    ['x-text']() {
      return this.status.message;
    },
  },
}));

Alpine.data('store_filter', (data) => ({
  selectedStore: 'ALL',
  mobileMenuIsOpen: true,
  scrollActive: false,
  init() {
    window.addEventListener('scroll', () => {
      if (this.scrollActive) return;
      this.mobileMenuIsOpen = false;
      this.scrollActive = true;
    });
  },

  select: {
    ['@click'](e) {
      this.selectedStore = e.target.dataset.key;
      setTimeout(() => {
        this.scrollActive = true;
        document
          .querySelector('#MainContent')
          .scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    },
  },
  mobile_menu_toggle: {
    ['@click'](e) {
      this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
    },
  },

  mobile_fade: {
    [':data-ui']() {
      return !this.mobileMenuIsOpen && 'close';
    },
  },
  mobile_menu: {
    [':data-ui']() {
      return this.mobileMenuIsOpen && 'open';
    },
  },
}));

Alpine.data('store_page', (data) => ({
  version: data.version,
  state: data.state,
  init() {},
  display_option_version_one: {
    [':data-ui']() {
      switch (this.state) {
        case 'IMAGES': {
          return 'image-show';
        }
        case 'MAP': {
          return 'map-show';
        }
      }
    },
  },
  display_option_version_two_scroll: {
    [':data-ui']() {
      return this.state == 'map' && 'hide';
    },
    ['x-effect']() {
      if (this.state !== this.$el.dataset.key) return;
      this.$el.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    },
  },
  display_option_version_two: {
    ['x-show']() {
      return this.state == this.$el.dataset.key;
    },
  },
  option_select: {
    [':data-ui'](e) {
      return this.state == this.$el.dataset.key && 'show';
    },
    ['@click'](e) {
      this.state = e.currentTarget.dataset.key;
      console.log(this.state, ' state');
    },
  },
}));

Alpine.data('map', (data) => ({
  id: data.id,
  coords: data.coords,
  pin: data.pin,

  init() {
    setTimeout(() => {
      this.initMap();
    }, 1000);
  },
  initMap() {
    const coords = this.coords;
    const map = new google.maps.Map(this.$root.querySelector(`#${this.id}`), {
      center: coords,
      zoom: 15,
      draggable: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      keyboardShortcuts: false,

      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      styles: [
        // Base land
        {
          elementType: 'geometry',
          stylers: [{ color: '#FAFAFA' }],
        },

        // Water
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#ECECEC' }],
        },

        // Roads
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#DCDCDC' }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#C8C8C8' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#BEBEBE' }],
        },

        // Labels – general
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#4A4A4A' }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#FAFAFA' }],
        },

        // City / locality labels (e.g. Melbourne)
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#000000' }],
        },

        {
          featureType: 'road',
          elementType: 'labels.text',
          stylers: [{ visibility: 'off' }],
        },
        // Parks
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#F0F0F0' }],
        },

        // Hide POI icons
        {
          featureType: 'poi',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },

        // Transit (very muted)
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#E6E6E6' }],
        },
        //  Hide suburb names
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text',
          stylers: [{ visibility: 'off' }],
        },

        //  Hide public transport
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.text',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });

    new google.maps.Marker({
      position: coords,
      map: map,
      icon: this.pin,
    });
  },
}));
